import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { PwaInstallService } from '../services/pwa-install.service';

/**
 * Blocks the slide editor and preview routes on mobile devices, where editing/previewing slides
 * is disabled (the slides list is view-only there). Redirects back to the slides list so a direct
 * URL can't reach the editor. On desktop it's a no-op.
 */
export const slidesEditorMobileGuard: CanActivateFn = (_route, state): boolean | UrlTree => {
  const pwa = inject(PwaInstallService);
  if (!pwa.isMobile) {
    return true;
  }

  const router = inject(Router);
  // Strip the trailing "/:slideId/editor" (or "/preview") → back to the slides list of the tenant.
  const listUrl = state.url.split('?')[0].split('/').slice(0, -2).join('/') || '/';
  return router.parseUrl(listUrl);
};
